import StoreLocator from './store-locator'

export default StoreLocator
